<template>
	<div>
		<ul
			class="overflow-auto align-items-center position-relative display-flex border-bottom border-white-darker-4 margin-bottom-big"
		>
			<slot></slot>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'b-nav-tabs'
};
</script>

<docs>
    ```js
    <b-nav-tabs />
    ```
</docs>
